import styled from 'styled-components';
import { Card } from '@shared/ui/Card';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Subtitle = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ActionsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
`;

export const KpiCard = styled(Card)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-left: 4px solid #10b981;
`;

export const KpiCardBankDetails = styled(KpiCard)`
  border-left-color: #0ea5e9;
`;

export const KpiCardSynced1C = styled(KpiCard)`
  border-left-color: #8b5cf6;
`;

export const KpiCardSuppliers = styled(KpiCard)`
  border-left-color: #f59e0b;
`;

export const KpiLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const KpiValue = styled.div`
  font-size: 26px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const KpiSub = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const FilterBar = styled(Card)`
  padding: 14px 18px;
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  background: ${({ theme }) => theme.colors.backgroundElevated};
`;

export const SearchInput = styled.input`
  padding: 8px 12px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;
  min-width: 260px;
  flex: 1;

  &:focus {
    outline: none;
    border-color: #10b981;
  }
`;

export const Select = styled.select`
  padding: 8px 12px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: #10b981;
  }
`;

/* Обе полосы прокрутки — в пределах окна: шапка таблицы (`th` в shared/ui/Table)
   закреплена и остаётся видна при прокрутке длинного списка. */
export const TableWrap = styled(Card)`
  padding: 0;
  overflow: auto;
  max-height: min(70vh, calc(100vh - 260px));
`;

export const ShownCaption = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CenterTh = styled.th`
  text-align: center;
`;

export const CenterTd = styled.td`
  text-align: center;
`;

export const TableNoticeTd = styled.td`
  text-align: center;
  padding: 24px;
`;

export const CounterpartyName = styled.div`
  font-weight: 700;
`;

export const CounterpartyFullName = styled.div`
  font-size: 11px;
  opacity: 0.7;
  max-width: 280px;
`;

export const CounterpartyUpdated = styled.div`
  font-size: 10px;
  opacity: 0.5;
  margin-top: 2px;
`;

export const InnText = styled.div`
  font-weight: 600;
`;

export const KppText = styled.div`
  font-size: 11px;
  opacity: 0.7;
`;

export const EmptyDash = styled.span`
  opacity: 0.4;
`;

export const BankNameText = styled.div`
  font-weight: 600;
  font-size: 12px;
`;

export const BikText = styled.div`
  font-size: 11px;
  opacity: 0.8;
`;

export const BikWarning = styled.span`
  font-size: 10px;
  color: #f59e0b;
  margin-left: 4px;
`;

export const MonoSpan = styled.span`
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-size: 12px;
  letter-spacing: 0.02em;
`;

export const VerifiedBadge = styled.span<{ $verified: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  background: ${({ $verified }) => ($verified ? '#10b98122' : '#f59e0b22')};
  color: ${({ $verified }) => ($verified ? '#10b981' : '#f59e0b')};
  border: 1px solid ${({ $verified }) => ($verified ? '#10b98155' : '#f59e0b55')};
`;

export const RequisitesHint = styled.div`
  font-size: 10px;
  color: #f59e0b;
  margin-top: 3px;
  max-width: 180px;
`;

export const AccountWarning = styled.div`
  font-size: 10px;
  color: #f59e0b;
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const SyncToast = styled.div<{ $success: boolean }>`
  padding: 12px 16px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ $success }) => ($success ? 'rgba(16, 185, 129, 0.12)' : 'rgba(239, 68, 68, 0.12)')};
  border: 1px solid ${({ $success }) => ($success ? '#10b981' : '#ef4444')};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

// =============================================================================
// Окно создания / редактирования контрагента (внутри shared/ui/Modal)
// =============================================================================

export const ModalBody = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: min(640px, 100%);
`;

export const FieldHint = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const FormErrorBox = styled.div`
  padding: 8px 12px;
  border-radius: 6px;
  background: rgba(239, 68, 68, 0.13);
  border: 1px solid #ef4444;
  color: #ef4444;
  font-size: 12px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const FormRow3 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Input = styled.input`
  padding: 8px 12px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: #10b981;
  }

  &[readonly] {
    color: ${({ theme }) => theme.colors.text.secondary};
    cursor: default;
  }

  &[aria-invalid='true'] {
    border-color: #ef4444;
  }
`;

export const BankRequisitesDivider = styled.div`
  font-size: 13px;
  font-weight: 700;
  margin-top: 6px;
  color: #10b981;
  border-bottom: 1px solid rgba(16, 185, 129, 0.27);
  padding-bottom: 4px;
`;

export const ModalFooter = styled.div`
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
